import type { Options } from "../types";
import { download } from "../utils";

export const json = (content: any, options: Options) => {
  download(JSON.stringify(content), options, "application/json");
};
